/**
 * DiCon Incident Service API
 * API used by DiCon, LiOn and Buefo.
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: dienstleistung@netze-bw.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Commune Contract Type
 */
export type ContractType = 'NO_MANAGEMENT' | 'BASIC_LEVEL' | 'COMFORT_LEVEL' | 'UNKNOWN';

export const ContractType = {
    NoManagement: 'NO_MANAGEMENT' as ContractType,
    BasicLevel: 'BASIC_LEVEL' as ContractType,
    ComfortLevel: 'COMFORT_LEVEL' as ContractType,
    Unknown: 'UNKNOWN' as ContractType
};

